<template>
  <vx-card>
    <div class="vx-row">
      <div class="vx-col w-full mb-4">
        <div class="flex justify-end">
          <strong class="mr-4">Status</strong>
          <strong :class="status == 1 ? 'text-success' : 'text-danger'">{{
            status == 1 ? "Disetujui" : "Belum Disetujui"
          }}</strong>
        </div>
      </div>
      <div class="vx-col w-full mb-8" v-if="preview_file !== null">
        <div class="flex justify-center relative">
          <!-- <a
            href="#"
            @click.prevent="unhandleFile"
            class="absolute"
            style="top: 0; right: 0"
          >
            <feather-icon icon="XIcon" svgClasses="text-danger"></feather-icon>
          </a> -->
          <img
            :src="`${url.baseFl}/${preview_file}`"
            alt="preview"
            class="w-full md:w-1/2 lg:w-1/3"
          />
        </div>
      </div>
      <!-- <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Gambar Sampul</strong></p>
        <input type="file" class="hidden" ref="file" @change="handleFile" />
        <vs-button
          class="rounded-none"
          color="primary"
          @click.prevent="$refs.file.click()"
        >
          Pilih Gambar
        </vs-button>
        <span class="text-danger text-sm" v-show="errors.has('file')">{{
          errors.first("file")
        }}</span>
      </div> -->
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Judul Campaign</strong></p>
        <section class="w-full break-words">
          <span
            class="text-xl"
            :style="name !== null ? 'color: black;' : 'color: red;'"
            >{{ name !== null ? name : "Judul Campaign Kosong" }}</span
          >
        </section>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Target Donasi</strong></p>
        <section class="w-full break-words">
          <span
            class="text-xl"
            :style="donasi !== null ? 'color: black;' : 'color: red;'"
            >{{ donasi !== null ? donasi : 0 | toCurrency }}</span
          >
        </section>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Tanggal Mulai</strong></p>
        <section class="w-full break-words">
          <span
            class="text-xl"
            :style="mulai !== null ? 'color: black;' : 'color: red;'"
            >{{ mulai !== null ? mulai : "Tanggal Mulai Kosong" }}</span
          >
        </section>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Tanggal Selesai</strong></p>
        <section class="w-full break-words">
          <span
            class="text-xl"
            :style="selesai !== null ? 'color: black;' : 'color: red;'"
            >{{ selesai !== null ? selesai : "Tanggal Selesai Kosong" }}</span
          >
        </section>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Kategori</strong></p>
        <section v-if="passData !== null" class="w-full break-words">
          <span
            class="text-xl"
            :style="
              passData.sub_kategori.kategori !== null ? 'color: black;' : 'color: red;'
            "
            >{{
              passData.sub_kategori.kategori !== null
                ? passData.sub_kategori.kategori.name
                : "Kategori Kosong"
            }}</span
          >
        </section>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Sub Kategori</strong></p>
        <section class="w-full break-words" v-if="passData !== null">
          <span
            class="text-xl"
            :style="passData.sub_kategori !== null ? 'color: black;' : 'color: red;'"
            >{{
              passData.sub_kategori !== null
                ? passData.sub_kategori.name
                : "Kategori Kosong"
            }}</span
          >
        </section>
      </div>
      <div class="vx-col w-full mb-8">
        <p class="mb-2"><strong>Deskripsi</strong></p>
        <section class="w-full break-words">
          <span
            v-if="deskripsi !== null"
            class="text-lg"
            v-html="deskripsi"
            style="color: black"
          >
          </span>
          <span v-else class="text-lg" style="color: red">Deskripsi Kosong</span>
        </section>
      </div>
      <div class="vx-col w-full mb-8">
        <p class="mb-2"><strong>RAB</strong></p>
        <section class="w-full break-words">
          <span class="text-lg" :style="rab !== null ? 'color: black;' : 'color: red;'">{{
            rab !== null ? rab : "RAB Kosong"
          }}</span>
        </section>
      </div>
      <div class="vx-col w-full mb-8">
        <p class="mb-2"><strong>Status Urgensi</strong></p>
        <section class="w-full break-words">
          <span
            class="text-xl"
            :style="status_priority !== null ? 'color: black;' : 'color: red;'"
            >{{
              status_priority !== null
                ? priority.find((v) => v.id === status_priority).text
                : "Status Urgensi Kosong"
            }}</span
          >
        </section>
      </div>
      <vs-divider position="left"
        ><span class="text-lg text-black mb-16"
          ><strong>Lokasi Campaign</strong></span
        ></vs-divider
      >
      <div class="vx-col sm:w-full md:w-4/12 lg:w-4/12 mb-8">
        <p class="mb-2"><strong>Provinsi</strong></p>
        <section class="w-full break-words" v-if="passData !== null">
          <span
            class="text-xl"
            :style="
              passData.kecamatan.kabkot.provinsi !== null
                ? 'color: black;'
                : 'color: red;'
            "
            >{{
              passData.kecamatan.kabkot.provinsi !== null
                ? passData.kecamatan.kabkot.provinsi.name
                : "Provinsi Kosong"
            }}</span
          >
        </section>
      </div>
      <div class="vx-col sm:w-full md:w-4/12 lg:w-4/12 mb-8">
        <p class="mb-2"><strong>Kabupaten/Kota</strong></p>
        <section class="w-full break-words" v-if="passData !== null">
          <span
            class="text-xl"
            :style="passData.kecamatan.kabkot !== null ? 'color: black;' : 'color: red;'"
            >{{
              passData.kecamatan.kabkot !== null
                ? passData.kecamatan.kabkot.name
                : "Kabupaten/Kota Kosong"
            }}</span
          >
        </section>
      </div>
      <div class="vx-col sm:w-full md:w-4/12 lg:w-4/12 mb-8">
        <p class="mb-2"><strong>Kecamatan</strong></p>
        <section class="w-full break-words" v-if="passData !== null">
          <span
            class="text-xl"
            :style="passData.kecamatan !== null ? 'color: black;' : 'color: red;'"
            >{{
              passData.kecamatan !== null ? passData.kecamatan.name : "Kecamatan Kosong"
            }}</span
          >
        </section>
      </div>
      <div class="vx-col w-full mb-8">
        <p class="mb-2"><strong>Alamat</strong></p>
        <section class="w-full break-words">
          <span
            class="text-xl"
            :style="alamat !== null ? 'color: black;' : 'color: red;'"
            >{{ alamat !== null ? alamat : "Alamat Kosong" }}</span
          >
        </section>
      </div>
      <vs-divider position="left"
        ><span class="text-lg text-black mb-16"><strong>PIC</strong></span></vs-divider
      >
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Nama PIC</strong></p>
        <section class="w-full break-words">
          <span
            class="text-xl"
            :style="namaPic !== null ? 'color: black;' : 'color: red;'"
            >{{ namaPic !== null ? namaPic : "Nama PIC Kosong" }}</span
          >
        </section>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>No.Telepon PIC</strong></p>
        <section class="w-full break-words">
          <span
            class="text-xl"
            :style="noTelpPic !== null ? 'color: black;' : 'color: red;'"
            >{{ noTelpPic !== null ? noTelpPic : "No.Telepon PIC Kosong" }}</span
          >
        </section>
      </div>
      <div class="vx-col w-full mb-8">
        <p class="mb-2"><strong>Alamat PIC</strong></p>
        <section class="w-full break-words">
          <span
            class="text-xl"
            :style="alamatPic !== null ? 'color: black;' : 'color: red;'"
            >{{ alamatPic !== null ? alamatPic : "Alamat PIC Kosong" }}</span
          >
        </section>
      </div>
      <vs-divider position="left"
        ><span class="text-lg text-black mb-16"
          ><strong>Video URL</strong></span
        ></vs-divider
      >
      <div class="vx-col w-full mb-8">
        <p class="mb-2"><strong>Masukan URL Video</strong></p>
        <section class="w-full break-words">
          <span
            class="text-xl"
            :style="videoUrl !== null ? 'color: black;' : 'color: red;'"
            >{{ videoUrl !== null ? videoUrl : "URL Video Kosong" }}</span
          >
        </section>
      </div>
      <div class="vx-col w-full mb-8">
        <p class="mb-4 flex justify-end"><strong>Aproval Campaign</strong></p>
        <div class="flex justify-end gap-2">
          <p>{{ statusSelect ? "Disetujui" : "Tidak Disetujui" }}</p>
          <vs-switch
            :color="statusSelect ? 'success' : 'danger'"
            v-model="statusSelect"
          />
        </div>
      </div>
      <div class="vx-col w-full md:w-1/5 lg:w-1/6">
        <vs-button class="rounded-none w-full" color="primary" @click.prevent="submit">
          SUBMIT
        </vs-button>
      </div>
    </div>
  </vx-card>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { Validator } from "vee-validate";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import vSelect from "vue-select";
import url from "@/url.js";

const dict = {
  custom: {
    urgent: {
      required: "Harap isi urgensi campaign",
    },
    name: {
      required: "Harap isi judul campaign",
    },
    file: {
      required: "Harap pilih gambar sampul",
    },
    mulai: {
      required: "Harap isi tanggal mulai",
    },
    selesai: {
      required: "Harap isi tanggal selesai",
    },
    donasi: {
      required: "Harap isi target donasi",
    },
    deskripsi: {
      required: "Harap isi deskripsi",
    },
    provinsi: {
      required: "Harap isi Provinsi",
    },
    kabkot: {
      required: "Harap isi Kabupaten/Kota",
    },
    alamat: {
      required: "Harap isi Alamat",
    },
    namaPic: {
      required: "Harap isi Nama PIC",
    },
    noTelpPic: {
      required: "Harap isi No.Telepon PIC",
    },
    alamatPic: {
      required: "Harap isi Alamat PIC",
    },
    videoUrl: {
      required: "Harap isi url video untuk penjelasan campaign",
    },
    slug: {
      required: "Harap isi judul Campaign untuk mendapatkan Slug",
    },
  },
};

// register custom messages
Validator.localize("en", dict);

export default {
  created() {
    this.$vs.loading.close();
    if (
      this.$store.state.campaign.kategoriList.length === 0 &&
      this.$store.state.campaign.subKategoriList.length === 0
    ) {
      this.getKategori();
      this.getSubKategori();
    } else {
      this.kategoriOptions = this.$store.state.campaign.kategoriList;
    }
  },
  methods: {
    getKategori() {
      this.$store.dispatch("campaign/getKatCampaign", {}).catch((e) => {
        if (e.response) {
          console.error(e.response.data.message);
          this.$vs.notify({
            position: "top-right",
            title: "Oops!",
            text: e.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      });
    },
    unhandleFile() {
      this.preview_file = null;
      this.file = null;
      this.$refs.file.value = "";
    },
    handleFile(e) {
      const objFile = e.target.files[0];

      if (!["image/jpeg", "image/png", "image/gif"].includes(objFile.type)) {
        e.target.value = "";
        this.$vs.notify({
          title: "Pemilihan gambar sampul gagal",
          text: "Selain file gambar tidak boleh",
          color: "warning",
          position: "top-right",
        });

        this.preview_file = null;
        this.file = null;

        return false;
      }

      // Create preview_file
      this.preview_file = URL.createObjectURL(objFile);
      this.file = objFile;
      console.log("file", this.file);
    },
    submit() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.kategori == null || this.sub_id == null) {
            this.$vs.notify({
              title: "Update Aproval Campaign Tidak Diizinkan!",
              text:
                "Campaign otomatis tidak disetujui karena kategori dan sub-kategori kosong",
              color: "warning",
              position: "top-right",
            });
            this.statusSelect = false;
            return false;
          }

          if (this.file == null && this.preview_file == null) {
            this.$vs.notify({
              title: "Update Aproval Campaign Tidak Diizinkan!",
              text: "Campaign otomatis tidak disetujui karena gambar unggulan kosong",
              color: "warning",
              position: "top-right",
            });
            this.statusSelect = false;
            return false;
          }

          if (this.rab == null) {
            this.$vs.notify({
              title: "Update Aproval Campaign Tidak Diizinkan!",
              text: "Campaign otomatis tidak disetujui karena RAB kosong",
              color: "warning",
              position: "top-right",
            });
            this.statusSelect = false;

            return false;
          }

          this.$vs.loading();
          let id = {};
          let payload = {
            file: this.preview_file,
            name: this.name,
            donasi: this.donasi,
            mulai: this.mulai,
            selesai: this.selesai,
            rab: this.rab,
            deskripsi: this.deskripsi,
            sub_id: this.sub_id,
            kat_id: this.kategori,
            user_id: this.user_id,
            status: this.status,
            status_priority: this.status_priority,
            kabkot_id: this.kabkot_id,
            provinsi_id: this.provinsi_id,
            kecamatan_id: this.kecamatan_id,
            alamat: this.alamat,
            video_url: this.videoUrl !== "" ? this.videoUrl : "-",
            nama_pic: this.namaPic,
            no_telp_pic: this.noTelpPic,
            alamat_pic: this.alamatPic,
            slug: this.slug,
          };

          if (this.detail !== null) {
            id = {
              id: this.detail.id,
            };
          }

          // let video = {}
          // if(this.videoUrl !== ""){
          //   video = {
          //     video_url: this.videoUrl
          //   }
          // }

          if (this.file !== null) {
            this.$store
              .dispatch("file/addFile", this.file)
              .then((result) => {
                this.file = result.link;

                this.$store
                  .dispatch("campaign/cudCampaign", [
                    {
                      ...payload,
                      ...id,
                      file: this.file,
                    },
                  ])
                  .then(() => {
                    this.$vs.loading.close();
                    this.$router.push("/dashboard/aproval-campaign");
                  })
                  .catch((e) => {
                    this.$vs.loading.close();
                    if (e.response) console.error(e.response);
                    this.$vs.notify({
                      title: "Oops",
                      text: e.response.data.message,
                      color: "warning",
                      position: "top-right",
                    });

                    return false;
                  });
              })
              .catch((e) => {
                this.$vs.loading.close();
                if (e.response) console.error(e.response);
                this.$vs.notify({
                  title: "Oops",
                  text: e.response.data.message,
                  color: "warning",
                  position: "top-right",
                });

                return false;
              });
          } else {
            if (this.preview_file !== null) {
              this.$store
                .dispatch("campaign/cudCampaign", [
                  { ...payload, ...id, file: this.preview_file },
                ])
                .then(() => {
                  this.$vs.loading.close();
                  this.$router.push("/dashboard/aproval-campaign");
                })
                .catch((e) => {
                  this.$vs.loading.close();
                  if (e.response) console.error(e.response);
                  this.$vs.notify({
                    title: "Oops",
                    text: e.response.data.message,
                    color: "warning",
                    position: "top-right",
                  });

                  return false;
                });
            } else {
              this.$vs.notify({
                title: "Harap pilih gambar sampul",
                text: "",
                color: "warning",
                position: "top-right",
              });

              return false;
            }
          }
        }
      });
    },
    getKecamatan() {
      this.$store
        .dispatch("wilayah/getKecamatan", { kabkot_id: this.kabkot_id })
        .then((v) => {
          this.kecamatanList = v.data;
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getDataDetail(id) {
      this.$vs.loading({
        color: "primary",
      });
      this.$store
        .dispatch("campaign/getDetailCampaign", id)
        .then((v) => {
          this.detail = v;
          this.fillDetail(v);
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    fillDetail(val) {
      this.passData = val;
      this.user_id = val.user.id;
      this.name = val.name;
      this.donasi = val.donasi;
      this.mulai = val.mulai;
      this.selesai = val.selesai;
      this.rab = val.rab;
      this.deskripsi = this.richtTextFormat(val.deskripsi);
      this.kategori = val.sub_kategori.kategori ? val.sub_kategori.kategori.id : null;
      this.sub_id = val.sub_kategori ? val.sub_kategori.id : null;
      this.preview_file = this.getPathFoto(val);
      this.status_priority = val.status_priority;
      this.status = val.status;
      this.provinsi_id = val.kecamatan.kabkot.provinsi
        ? val.kecamatan.kabkot.provinsi.id
        : null;
      this.kabkot_id = val.kecamatan.kabkot ? val.kecamatan.kabkot.id : null;
      this.kecamatan_id = val.kecamatan ? val.kecamatan.id : null;
      this.alamat = val.alamat;
      this.namaPic = val.nama_pic;
      this.noTelpPic = val.no_telp_pic;
      this.alamatPic = val.alamat_pic;
      this.videoUrl = val.video_url;
      this.slug = val.slug;
      this.statusSelect = val.status === 1;
    },
    getSubKategori() {
      this.$store.dispatch("campaign/getSubKatCampaign", {}).catch((e) => {
        if (e.response) {
          console.error(e.response.data.message);
          this.$vs.notify({
            position: "top-right",
            title: "Oops!",
            text: e.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      });
    },
  },
  watch: {
    kategori() {
      if (this.kategori !== null) {
        this.subKategoriOptions = this.$store.getters["campaign/filterSubKategori"](
          this.kategori
        );
      }
    },
    statusSelect() {
      if (this.statusSelect) {
        this.status = 1;
      } else {
        this.status = 0;
      }
    },
    kategoriList() {
      if (this.$store.state.campaign.kategoriList.length !== 0) {
        this.kategoriOptions = this.$store.state.campaign.kategoriList;
      }
    },
    provinsi_id() {
      if (this.provinsi_id !== null) {
        this.kabKotList = this.$store.getters["wilayah/getFilteredKabKot"](
          this.provinsi_id
        );
      }
    },
    name() {
      if (this.name !== "" || this.name !== null) {
        this.slugFormatter = this.name;
      }
    },
    kabkot_id() {
      if (this.kabkot_id !== null) {
        this.getKecamatan(this.kabkot_id);
      }
    },
  },
  components: {
    VuePhoneNumberInput,
    quillEditor,
    vSelect,
  },
  mounted() {
    this.provinsiList = this.$store.state.wilayah.provinsiList;

    if (this.$route.params.id !== undefined) {
      if (this.$store.state.campaign.campaign.length !== 0) {
        this.detail = this.$store.getters["campaign/detail"](this.$route.params.id);
        this.fillDetail(this.detail);
      } else {
        this.getDataDetail(this.$route.params.id);
      }
    }
  },
  computed: {
    profile() {
      return JSON.parse(localStorage.profileAccess).profile;
    },
    kategoriList() {
      return this.$store.state.campaign.kategoriList;
    },
    slugFormatter: {
      get() {
        return this.slug;
      },
      set(v) {
        this.slug = v.replaceAll(" ", "-").toLowerCase();
      },
    },
  },
  data: () => ({
    url,
    preview_file: null,
    name: null,
    file: null,
    donasi: null,
    mulai: null,
    selesai: null,
    deskripsi: null,
    status_priority: null,
    rab: null,
    user_id: null,
    sub_id: null,
    kategori: null,
    kategoriOptions: [],
    subKategoriOptions: [],
    status: 0,
    statusSelect: false,
    detail: null,
    kecamatan_id: null,
    provinsi_id: null,
    kabkot_id: null,
    provinsiList: [],
    kabKotList: [],
    kecamatanList: [],
    alamat: "",
    namaPic: "",
    noTelpPic: "",
    alamatPic: "",
    videoUrl: "",
    slug: "",
    passData: null,
    priority: [
      {
        id: 0,
        text: "Normal",
      },
      {
        id: 1,
        text: "Darurat",
      },
    ],
    editorOptions: {
      modules: {
        toolbar: {
          container: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ["clean"],
            ["image"],
          ],
        },
      },
    },
  }),
};
</script>
